export default {"src":"/kaimono/_next/static/media/cn_wamazing_play_h.4dc0db63.svg","height":116,"width":335};